import { FlexGrid, Header, Layer, Row } from "@carbon/react";
import React from "react";

import BrandLogo from "src/pages/Sidebar/BrandLogo.tsx";
import FlaminemLogo from "src/pages/Sidebar/FlaminemLogo.tsx";

export const GlobalErrorLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <FlexGrid className="min-w-min">
      <Row>
        <Header aria-label="Flaminem" className="border-solid ">
          <BrandLogo />
          <FlaminemLogo showMenu={false} />
        </Header>
      </Row>
      <Row>
        <main
          className="cds--content"
          style={{
            marginTop: "2.5rem",
            padding: "1.5rem",
            minHeight: "calc(100vh - 2.5rem)",
            background: "var(--cds-field)",
          }}
        >
          <Layer level={1}>{children}</Layer>
        </main>
      </Row>
    </FlexGrid>
  );
};
